import { createClient } from '@supabase/supabase-js';

/*
 * De project-URL en de publishable key komen uit de omgeving (.env of de
 * omgevingsvariabelen van de hosting) en worden tijdens het bouwen ingevuld.
 * Ze komen dus in de bundel terecht, en dat mag: na migratie 006 heeft de rol
 * `anon` geen enkel recht meer, dus deze sleutel opent niets. Alles loopt via
 * het inlogtoken dat je na het inloggen krijgt.
 *
 * Ontbreken ze, dan start de app in demomodus met verzonnen data — handig om
 * te ontwikkelen of de app te laten zien zonder database.
 */

const url = import.meta.env.VITE_SUPABASE_URL as string | undefined;
const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY as string | undefined;

export const supabaseIngesteld = Boolean(url && anonKey && !url.includes('xxxxx'));

export const projectUrl = url ?? '';

export const supabase = supabaseIngesteld
  ? createClient(url as string, anonKey as string, {
      auth: {
        persistSession: true,
        autoRefreshToken: true,
        detectSessionInUrl: false
      }
    })
  : null;

/** Roept de client op en klaagt duidelijk als hij er niet is. */
export function client() {
  if (!supabase) {
    throw new Error('Geen Supabase ingesteld. Vul VITE_SUPABASE_URL en VITE_SUPABASE_ANON_KEY in.');
  }
  return supabase;
}
